import React from 'react';
import { Bell } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';
interface HomeHeaderProps {
  onNavigate?: (screen: string) => void;
}
export function HomeHeader({
  onNavigate
}: HomeHeaderProps) {
  const {
    isLight
  } = useTheme();
  return <div className="flex justify-between items-center" data-tour="home-header" data-id="element-376" data-mp="1caai3zeaqc8x">
      <div className="flex items-center gap-2.5" data-id="element-377" data-mp="18btcjkaix9tm">
        <img src="https://cdn.magicpatterns.com/uploads/3A8d459aXLumR8KKFCQtrD/vexu_logo.svg" alt="Vexu" className="w-7 h-7 object-contain" data-id="element-378" data-mp="kknv50oxq9h7" />
        <span className={`text-lg font-bold tracking-tight ${isLight ? 'text-slate-900' : 'text-white'}`} data-id="element-379" data-mp="tdirf4wfcuuu">
          Vexu.ai
        </span>
      </div>
      <button onClick={() => onNavigate?.('notifications')} className={`w-9 h-9 rounded-full flex items-center justify-center backdrop-blur-2xl transition-all ${isLight ? 'bg-white/80 border border-slate-200/50 shadow-[0_2px_8px_rgba(0,0,0,0.04)]' : 'bg-white/[0.06] border border-white/[0.06] shadow-[0_2px_8px_rgba(0,0,0,0.2)]'}`} data-id="element-380" data-mp="okxz67t62ptf">
        <div className="relative" data-id="element-381" data-mp="128yz5owbmdc9">
          <Bell className={`w-[17px] h-[17px] ${isLight ? 'text-slate-500' : 'text-zinc-400'}`} strokeWidth={1.6} data-id="element-382" data-mp="1287bd08ytjwj" />
          <span className="absolute -top-0.5 -right-0.5 w-2 h-2 rounded-full bg-vexu shadow-[0_0_4px_rgba(0,200,83,0.5)]" data-id="element-383" data-mp="1c03cyla9fs5i" />
        </div>
      </button>
    </div>;
}